var ImportDialog, ImportDialogView, ReactComponent, View,
  __hasProp = {}.hasOwnProperty,
  __extends = function(child, parent) { for (var key in parent) { if (__hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; };

View = require('base/views/view');

ReactComponent = require('base/lib/traits/react_component');

ImportDialog = require('components/import_dialog/import_dialog');

module.exports = ImportDialogView = (function(_super) {
  __extends(ImportDialogView, _super);

  function ImportDialogView() {
    return ImportDialogView.__super__.constructor.apply(this, arguments);
  }

  ImportDialogView.prototype.autoRender = true;

  ImportDialogView.prototype.initialize = function() {
    this.enable(ReactComponent);
    return ImportDialogView.__super__.initialize.apply(this, arguments);
  };

  ImportDialogView.prototype.afterRender = function() {
    ImportDialogView.__super__.afterRender.apply(this, arguments);
    return this.renderSimpleComponent(ImportDialog);
  };

  ImportDialogView.prototype.dispose = function() {
    if (this.disposed) {
      return;
    }
    this.unmountComponent();
    return ImportDialogView.__super__.dispose.apply(this, arguments);
  };

  return ImportDialogView;

})(View);
